<template>
  <div class="back-to-dashboard">
    <a @click="goBackToDashboard">
      <icon icon="angle-left" />
      <span>{{ breadcrumbText }}</span>
    </a>
  </div>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import dashboardType from '@/helpers/enums/dashboardType'
import navigationHistoryService from '@/services/navigationHistoryService'

export default {
  components: {
    Icon,
  },
  props: {
    type: {
      type: String,
      default: dashboardType.quote,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    breadcrumbText() {
      let previousRoute = navigationHistoryService.getPreviousRoute()
      let currentRoute = navigationHistoryService.getCurrentRoute(this.$route)

      if (
        previousRoute?.name === 'configuration-page' &&
        currentRoute?.name === 'change-order-page'
      ) {
        return 'Terug naar order ' + previousRoute.params.quoteId
      }

      return this.i18n.t('/QuotePage/BackButton')
    },
  },
  methods: {
    goBackToDashboard() {
      let previousRoute = navigationHistoryService.getPreviousRoute()
      let currentRoute = navigationHistoryService.getCurrentRoute(this.$route)

      if (
        previousRoute?.name === 'configuration-page' &&
        currentRoute?.name === 'change-order-page'
      ) {
        this.$router.push({
          name: previousRoute.name,
          params: previousRoute?.params,
        })
      } else {
        //default behavior
        switch (this.type) {
          case dashboardType.changeOrder:
            this.$router.push({
              name: 'change-orders-page',
              params: {
                establishmentId: this.$route.params.establishmentId,
              },
            })
            break
          case dashboardType.purchaseOrder:
            this.$router.push({
              name: 'purchase-orders-page',
              params: {
                establishmentId: this.$route.params.establishmentId,
              },
            })
            break
          case dashboardType.quote:
          default:
            if (this.$route.query.returnUrl) {
              // If we have a returnUrl, use it and preserve the tab parameter
              const returnUrl = this.$route.query.returnUrl
              const tabParam = this.$route.query.tab

              if (tabParam !== undefined) {
                // Add tab parameter to the return URL
                const separator = returnUrl.includes('?') ? '&' : '?'
                this.$router.push(`${returnUrl}${separator}tab=${tabParam}`)
              } else {
                this.$router.push(returnUrl)
              }
            } else {
              // Default navigation, preserve tab parameter if present
              const query = {}
              if (this.$route.query.tab !== undefined) {
                query.tab = this.$route.query.tab
              }

              this.$router.push({
                name: 'quote-overview-page',
                params: {
                  cstType: this.$route.params.cstType,
                  establishmentId: this.$route.params.establishmentId,
                },
                query,
              })
            }
            break
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.back-to-dashboard {
  padding-top: 1.25rem;

  > a {
    text-decoration: none;
    display: flex;
    align-items: center;
  }
}
</style>
